export enum PermitType {
  "Food Handler" = 1,
  "Non-Food Handler" = 2,
  "Entertainer (Female)" = 3,
  "Entertainer (Male)" = 4
}
